import { z } from 'zod';

import { reportErrorToSentry } from '#configuration/setup/sentry.ts';

export const parseGeoCoordinateNumber = (data: string | undefined) =>
    z
        .preprocess(val => {
            const parsed = typeof val === 'string' ? Number.parseFloat(val) : val;
            if (typeof parsed === 'number' && !Number.isFinite(parsed)) {
                return undefined;
            }
            return parsed;
        }, z.number().optional())
        .catch(ctx => {
            reportErrorToSentry(ctx.error);
            return undefined;
        })
        .parse(data);

export const parseGeoCoordinateString = (data: number | undefined) =>
    z
        .preprocess(val => (typeof val === 'number' ? val.toString() : val), z.string())
        .catch(ctx => {
            reportErrorToSentry(ctx.error);
            return '';
        })
        .parse(data);
